/**
 * Page header for the products listing: "Products" title + the mobile
 * "Filters" button (with active-filter badge). The sort `<Select>` lives
 * inside the filter sidebar itself — this component only owns the header row
 * that appears above the grid.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1471–1488.
 */

"use client";

import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProductSortBarProps {
  activeFilterCount: number;
  onOpenFilters: () => void;
}

export function ProductSortBar({
  activeFilterCount,
  onOpenFilters,
}: ProductSortBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <h2 className="heading-page">Products</h2>
      <Button
        variant="outline"
        size="sm"
        onClick={onOpenFilters}
        aria-label={
          activeFilterCount > 0
            ? `Filters (${activeFilterCount} active)`
            : "Filters"
        }
        className="relative shrink-0 min-h-11 min-w-11 sm:min-h-0 sm:min-w-0 lg:hidden"
      >
        <SlidersHorizontal className="h-4 w-4 sm:mr-2" />
        <span className="hidden sm:inline">Filters</span>
        {activeFilterCount > 0 && (
          <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground sm:static sm:ml-1.5">
            {activeFilterCount}
          </span>
        )}
      </Button>
    </div>
  );
}
